{
  "role": "http://xbrl.ssm.com.my/role/ssm/rol_ssmt-fs-mfrs_2022-12-31/ssmt-fs-mfrs_2022-12-31_role-220100",
  "definition": "[220100] Sub-classification of assets, liabilities and equity, by order of liquidity method",
  "sheetId": "SubClassificationLiquidity",
  "label": "Sub-classification of assets, liabilities and equity (Liquidity Order)",
  "controls": [
    {
      "qname": "ssmt:SubClassificationOfAssetsLiabilitiesEquityLiquidityExplanatory",
      "label": "Explanatory note for sub-classification by liquidity",
      "type": "TextBlockItemType",
      "ui": {
        "control": "textarea",
        "placeholder": "Provide details on the sub-classification of assets, liabilities and equity presented by order of liquidity...",
        "rows": 6
      },
      "required": false
    },
    {
      "qname": "ssmt:PropertyPlantEquipmentHeader",
      "label": "PROPERTY, PLANT AND EQUIPMENT",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": "h3"
      }
    },
    {
      "qname": "ssmt:LandAndBuildingsLiquidity",
      "label": "Land and buildings",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "placeholder": "0",
        "currency": "MYR",
        "dualColumn": true
      },
      "required": false,
      "validators": [{"name": "min", "value": 0}]
    },
    {
      "qname": "ssmt:PlantAndMachineryLiquidity",
      "label": "Plant and machinery",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "placeholder": "0",
        "currency": "MYR",
        "dualColumn": true
      },
      "required": false,
      "validators": [{"name": "min", "value": 0}]
    },
    {
      "qname": "ssmt:MotorVehiclesLiquidity",
      "label": "Motor vehicles",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "placeholder": "0",
        "currency": "MYR",
        "dualColumn": true
      },
      "required": false,
      "validators": [{"name": "min", "value": 0}]
    },
    {
      "qname": "ssmt:FurnitureFixturesAndFittingsLiquidity",
      "label": "Furniture, fixtures and fittings",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "placeholder": "0",
        "currency": "MYR",
        "dualColumn": true
      },
      "required": false,
      "validators": [{"name": "min", "value": 0}]
    },
    {
      "qname": "ssmt:OfficeEquipmentLiquidity",
      "label": "Office equipment",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "placeholder": "0",
        "currency": "MYR",
        "dualColumn": true
      },
      "required": false,
      "validators": [{"name": "min", "value": 0}]
    },
    {
      "qname": "ssmt:CapitalWorkInProgressLiquidity",
      "label": "Capital work-in-progress",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "placeholder": "0",
        "currency": "MYR",
        "dualColumn": true
      },
      "required": false,
      "validators": [{"name": "min", "value": 0}]
    },
    {
      "qname": "ssmt:PropertyPlantAndEquipmentSubClassificationLiquidity",
      "label": "TOTAL - Property, plant and equipment",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "placeholder": "0",
        "currency": "MYR",
        "calculated": true,
        "readonly": true,
        "dualColumn": true
      },
      "required": false,
      "validators": [{"name": "min", "value": 0}]
    },
    {
      "qname": "ssmt:IntangibleAssetsHeader",
      "label": "INTANGIBLE ASSETS",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": "h3"
      }
    },
    {
      "qname": "ssmt:ComputerSoftwareLiquidity",
      "label": "Computer software",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "placeholder": "0",
        "currency": "MYR",
        "dualColumn": true
      },
      "required": false,
      "validators": [{"name": "min", "value": 0}]
    },
    {
      "qname": "ssmt:GoodwillLiquidity",
      "label": "Goodwill",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "placeholder": "0",
        "currency": "MYR",
        "dualColumn": true
      },
      "required": false,
      "validators": [{"name": "min", "value": 0}]
    },
    {
      "qname": "ssmt:BrandNamesLiquidity",
      "label": "Brand names",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "placeholder": "0",
        "currency": "MYR",
        "dualColumn": true
      },
      "required": false,
      "validators": [{"name": "min", "value": 0}]
    },
    {
      "qname": "ssmt:OtherIntangibleAssetsLiquidity",
      "label": "Other intangible assets",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "placeholder": "0",
        "currency": "MYR",
        "dualColumn": true
      },
      "required": false,
      "validators": [{"name": "min", "value": 0}]
    },
    {
      "qname": "ssmt:IntangibleAssetsSubClassificationLiquidity",
      "label": "TOTAL - Intangible assets",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "placeholder": "0",
        "currency": "MYR",
        "calculated": true,
        "readonly": true,
        "dualColumn": true
      },
      "required": false,
      "validators": [{"name": "min", "value": 0}]
    },
    {
      "qname": "ssmt:InventoriesHeader",
      "label": "INVENTORIES",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": "h3"
      }
    },
    {
      "qname": "ssmt:RawMaterialsLiquidity",
      "label": "Raw materials",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "placeholder": "0",
        "currency": "MYR",
        "dualColumn": true
      },
      "required": false,
      "validators": [{"name": "min", "value": 0}]
    },
    {
      "qname": "ssmt:WorkInProgressLiquidity",
      "label": "Work-in-progress",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "placeholder": "0",
        "currency": "MYR",
        "dualColumn": true
      },
      "required": false,
      "validators": [{"name": "min", "value": 0}]
    },
    {
      "qname": "ssmt:FinishedGoodsLiquidity",
      "label": "Finished goods",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "placeholder": "0",
        "currency": "MYR",
        "dualColumn": true
      },
      "required": false,
      "validators": [{"name": "min", "value": 0}]
    },
    {
      "qname": "ssmt:ConsumablesAndSparesLiquidity",
      "label": "Consumables and spares",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "placeholder": "0",
        "currency": "MYR",
        "dualColumn": true
      },
      "required": false,
      "validators": [{"name": "min", "value": 0}]
    },
    {
      "qname": "ssmt:InventoriesSubClassificationLiquidity",
      "label": "TOTAL - Inventories",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "placeholder": "0",
        "currency": "MYR",
        "calculated": true,
        "readonly": true,
        "dualColumn": true
      },
      "required": false,
      "validators": [{"name": "min", "value": 0}]
    },
    {
      "qname": "ssmt:TradeReceivablesHeader",
      "label": "TRADE RECEIVABLES",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": "h3"
      }
    },
    {
      "qname": "ssmt:TradeReceivablesGrossAmountLiquidity",
      "label": "Trade receivables - Gross amount",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "placeholder": "0",
        "currency": "MYR",
        "dualColumn": true
      },
      "required": false,
      "validators": [{"name": "min", "value": 0}]
    },
    {
      "qname": "ssmt:AllowanceForDoubtfulDebtsLiquidity",
      "label": "Less: Allowance for doubtful debts",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "placeholder": "0",
        "currency": "MYR",
        "dualColumn": true
      },
      "required": false,
      "validators": [{"name": "min", "value": 0}]
    },
    {
      "qname": "ssmt:TradeReceivablesNetAmountLiquidity",
      "label": "Trade receivables - Net amount",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "placeholder": "0",
        "currency": "MYR",
        "calculated": true,
        "readonly": true,
        "dualColumn": true
      },
      "required": false,
      "validators": [{"name": "min", "value": 0}]
    },
    {
      "qname": "ssmt:OtherReceivablesHeader",
      "label": "OTHER RECEIVABLES",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": "h3"
      }
    },
    {
      "qname": "ssmt:DepositsLiquidity",
      "label": "Deposits",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "placeholder": "0",
        "currency": "MYR",
        "dualColumn": true
      },
      "required": false,
      "validators": [{"name": "min", "value": 0}]
    },
    {
      "qname": "ssmt:PrepaymentsLiquidity",
      "label": "Prepayments",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "placeholder": "0",
        "currency": "MYR",
        "dualColumn": true
      },
      "required": false,
      "validators": [{"name": "min", "value": 0}]
    },
    {
      "qname": "ssmt:AccruedIncomeLiquidity",
      "label": "Accrued income",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "placeholder": "0",
        "currency": "MYR",
        "dualColumn": true
      },
      "required": false,
      "validators": [{"name": "min", "value": 0}]
    },
    {
      "qname": "ssmt:OtherReceivablesSubClassificationLiquidity",
      "label": "TOTAL - Other receivables",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "placeholder": "0",
        "currency": "MYR",
        "calculated": true,
        "readonly": true,
        "dualColumn": true
      },
      "required": false,
      "validators": [{"name": "min", "value": 0}]
    },
    {
      "qname": "ssmt:TradePayablesHeader",
      "label": "TRADE PAYABLES",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": "h3"
      }
    },
    {
      "qname": "ssmt:TradePayablesDomesticLiquidity",
      "label": "Trade payables - Domestic",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "placeholder": "0",
        "currency": "MYR",
        "dualColumn": true
      },
      "required": false,
      "validators": [{"name": "min", "value": 0}]
    },
    {
      "qname": "ssmt:TradePayablesForeignLiquidity",
      "label": "Trade payables - Foreign",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "placeholder": "0",
        "currency": "MYR",
        "dualColumn": true
      },
      "required": false,
      "validators": [{"name": "min", "value": 0}]
    },
    {
      "qname": "ssmt:TradePayablesSubClassificationLiquidity",
      "label": "TOTAL - Trade payables",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "placeholder": "0",
        "currency": "MYR",
        "calculated": true,
        "readonly": true,
        "dualColumn": true
      },
      "required": false,
      "validators": [{"name": "min", "value": 0}]
    },
    {
      "qname": "ssmt:OtherPayablesHeader",
      "label": "OTHER PAYABLES",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": "h3"
      }
    },
    {
      "qname": "ssmt:AccruedExpensesLiquidity",
      "label": "Accrued expenses",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "placeholder": "0",
        "currency": "MYR",
        "dualColumn": true
      },
      "required": false,
      "validators": [{"name": "min", "value": 0}]
    },
    {
      "qname": "ssmt:DepositsReceivedLiquidity",
      "label": "Deposits received",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "placeholder": "0",
        "currency": "MYR",
        "dualColumn": true
      },
      "required": false,
      "validators": [{"name": "min", "value": 0}]
    },
    {
      "qname": "ssmt:SundryPayablesLiquidity",
      "label": "Sundry payables",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "placeholder": "0",
        "currency": "MYR",
        "dualColumn": true
      },
      "required": false,
      "validators": [{"name": "min", "value": 0}]
    },
    {
      "qname": "ssmt:OtherPayablesSubClassificationLiquidity",
      "label": "TOTAL - Other payables",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "placeholder": "0",
        "currency": "MYR",
        "calculated": true,
        "readonly": true,
        "dualColumn": true
      },
      "required": false,
      "validators": [{"name": "min", "value": 0}]
    },
    {
      "qname": "ssmt:BorrowingsHeader",
      "label": "BORROWINGS",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": "h3"
      }
    },
    {
      "qname": "ssmt:BankOverdraftsSubClassificationLiquidity",
      "label": "Bank overdrafts",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "placeholder": "0",
        "currency": "MYR",
        "dualColumn": true
      },
      "required": false,
      "validators": [{"name": "min", "value": 0}]
    },
    {
      "qname": "ssmt:TermLoansLiquidity",
      "label": "Term loans",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "placeholder": "0",
        "currency": "MYR",
        "dualColumn": true
      },
      "required": false,
      "validators": [{"name": "min", "value": 0}]
    },
    {
      "qname": "ssmt:RevolvingCreditLiquidity",
      "label": "Revolving credit",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "placeholder": "0",
        "currency": "MYR",
        "dualColumn": true
      },
      "required": false,
      "validators": [{"name": "min", "value": 0}]
    },
    {
      "qname": "ssmt:OtherBorrowingsLiquidity",
      "label": "Other borrowings",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "placeholder": "0",
        "currency": "MYR",
        "dualColumn": true
      },
      "required": false,
      "validators": [{"name": "min", "value": 0}]
    },
    {
      "qname": "ssmt:BorrowingsSubClassificationLiquidity",
      "label": "TOTAL - Borrowings",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "placeholder": "0",
        "currency": "MYR",
        "calculated": true,
        "readonly": true,
        "dualColumn": true
      },
      "required": false,
      "validators": [{"name": "min", "value": 0}]
    },
    {
      "qname": "ssmt:ShareCapitalHeader",
      "label": "SHARE CAPITAL",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": "h3"
      }
    },
    {
      "qname": "ssmt:OrdinarySharesLiquidity",
      "label": "Ordinary shares",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "placeholder": "0",
        "currency": "MYR",
        "dualColumn": true
      },
      "required": false,
      "validators": [{"name": "min", "value": 0}]
    },
    {
      "qname": "ssmt:PreferenceSharesLiquidity",
      "label": "Preference shares",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "placeholder": "0",
        "currency": "MYR",
        "dualColumn": true
      },
      "required": false,
      "validators": [{"name": "min", "value": 0}]
    },
    {
      "qname": "ssmt:ShareCapitalSubClassificationLiquidity",
      "label": "TOTAL - Share capital",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "placeholder": "0",
        "currency": "MYR",
        "calculated": true,
        "readonly": true,
        "dualColumn": true
      },
      "required": false,
      "validators": [{"name": "min", "value": 0}]
    },
    {
      "qname": "ssmt:OtherReservesHeader",
      "label": "OTHER RESERVES",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": "h3"
      }
    },
    {
      "qname": "ssmt:RevaluationSurplusLiquidity",
      "label": "Revaluation surplus",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "placeholder": "0",
        "currency": "MYR",
        "dualColumn": true
      },
      "required": false,
      "validators": [{"name": "min", "value": 0}]
    },
    {
      "qname": "ssmt:ForeignCurrencyTranslationReserveLiquidity",
      "label": "Foreign currency translation reserve",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "placeholder": "0",
        "currency": "MYR",
        "dualColumn": true
      },
      "required": false,
      "validators": [{"name": "min", "value": 0}]
    },
    {
      "qname": "ssmt:OtherCapitalReservesLiquidity",
      "label": "Other capital reserves",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "placeholder": "0",
        "currency": "MYR",
        "dualColumn": true
      },
      "required": false,
      "validators": [{"name": "min", "value": 0}]
    },
    {
      "qname": "ssmt:OtherReservesSubClassificationLiquidity",
      "label": "TOTAL - Other reserves",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "placeholder": "0",
        "currency": "MYR",
        "calculated": true,
        "readonly": true,
        "dualColumn": true
      },
      "required": false,
      "validators": [{"name": "min", "value": 0}]
    }
  ]
}
